import { createRef } from 'react';
import { useSelector } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import { removeToast, TOAST_TYPE } from '../../store/slices/toaster.slice';
import { Toast } from './Toast';

import './Toaster.scss';

export const Toaster = () => {
  const toasts = useSelector((state) => state.toasts);

  const toastItems = toasts.map((toast) => {
    const toastRef = createRef(null);
    return { ...toast, toastRef };
  });

  return (
    <div className="toasts-list">
      <TransitionGroup>
        {toastItems.map((toast) => (
          <CSSTransition key={toast.id} nodeRef={toast.toastRef} timeout={300} classNames="fade">
            <Toast
              id={toast.id}
              body={toast.body}
              options={toast.options}
              removeToast={removeToast}
              ref={toast.toastRef}
            >
              {toast.body.message}
            </Toast>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </div>
  );
};

export default Toaster;
